import fetch from '@/utils/fetch'
import store from '../store'
//验证码
export function getCheckCode() {
  return fetch({
    url: '/apiuser/codeimg',
    method: 'get'
  })
}

//注册
export function registerByAccount(data) {
  return fetch({
    url: '/apiuser/register', //mockUrl: url: '/register/registerbyaccount'
    method: 'post',
    data
  })
}

//登录
export function loginByAccount(data) {
  return fetch({
    url: '/apiuser/signin', //mockUrl: url: '/register/registerbyaccount'
    method: 'post',
    data
  })
}

//退出登录
export function logout(data) {
  return fetch({
    url: '/apiuser/signinOut', //mockUrl: url: '/register/registerbyaccount'
    method: 'post',
    data
  })
}

// 发送邮箱验证码
 export function sendEmailCode(data) {
  return fetch({
    url: '/apiuser/send_email',
    method: 'post',
    data
  })
 }

 //绑定邮箱
 export function bindEmail(data) {
  return fetch({
    url: '/apiuser/bindmail',
    method: 'post',
    data
  })
 }

  //解绑邮箱验证验证码
export function unbindVerify(data) {
  return fetch({
    url: '/apiuser/unbind_verify',
    method: 'post',
    data
  })
}

 //解绑邮箱
export function unbindEmail(data) {
  return fetch({
    url: '/apiuser/unbind',
    method: 'post',
    data
  })
}

//修改密码-1验证安全信息
export function verifyInfo(data) {
  return fetch({
    url: '/apiuser/verifyInfo',
    method: 'post',
    data
  })
}

// 修改密码-2重置密码

export function changePass(data) {
  return fetch({
    url: '/apiuser/changePass',
    method: 'post',
    data
  })
}

// 忘记密码-1输入龙图账号
export function inputAccount(data) {
  return fetch({
    url: '/apiuser/inputAccount',
    method: 'post',
    data
  })
}

//忘记密码-2验证安全信息
export function confirmInfo(data) {
  return fetch({
    url: '/apiuser/confirminfo',
    method: 'post',
    data
  })
}

// 忘记密码-3重置密码
export function resetPass(data) {
  return fetch({
    url: '/apiuser/resetpass',
    method: 'post',
    data
  })
}

//用户基本资料
export function baseData(data) {
  return fetch({
    url: '/apiuser/index',
    method: 'post',
    data
  })
}

//充值记录
export function rechargeRecord(data) {
  return fetch({
    url: '/apipay/payList',
    method: 'post',
    data
  })
}

//兑换记录
export function exchangeRecord(data) {
  return fetch({
    url: '/apipay/payList',
    method: 'post',
    data
  })
}

// 获取充值方式
export function getRechargeMethod(data) {
  const dataAddUid = data
  dataAddUid.uid = store.getters.uid
  return fetch({
    url: '/apipay/recharge',
    method: 'post',
    data: dataAddUid
  })
}

// 获取充值套餐
export function getChannelUnit(data) {
  const dataAddUid = data
  dataAddUid.uid = store.getters.uid
  return fetch({
    url: '/apipay/getChannelUnit',
    method: 'post',
    data: dataAddUid
  })
}

// 删除充值订单
export function cancelPayment(data) {
  return fetch({
    url: '/apipay/cancelPayment',
    method: 'post',
    data
  })
}

// 充值兑换-点击充值按钮
export function processRecharge(data) {
  return fetch({
    url: '/apipay/process',
    method: 'post',
    data
  })
}

// 充值兑换-兑换到游戏-游戏列表
export function getExchangeGameList(data) {
  const dataAddUid = data
  dataAddUid.uid = store.getters.uid
  return fetch({
    url: '/apipay/exchange',
    method: 'post',
    data: dataAddUid
  })
}

// 充值兑换-兑换到游戏-服务器列表
export function getExchangeServiceList(data) {
  const dataAddUid = data
  dataAddUid.uid = store.getters.uid
  return fetch({
    url: '/apipay/exchange',
    method: 'post',
    data: dataAddUid
  })
}

// 充值兑换-兑换到游戏-服务器列表
export function getExchangeRoleList(data) {
  const dataAddUid = data
  dataAddUid.uid = store.getters.uid
  return fetch({
    url: '/apipay/exchange',
    method: 'post',
    data: dataAddUid
  })
}

//充值兑换-点击确认兑换
export function eprocessExchange(data) {
  const dataAddUid = data
  dataAddUid.uid = store.getters.uid
  return fetch({
    url: '/apipay/eprocess',
    method: 'post',
    data: dataAddUid
  })
}




// WEBPACK FOOTER //
// ./src/api/user.js